import axios from "axios";

const insuranceHttp = axios.create({
  baseURL: process.env.REACT_APP_API_INSURANCE_URL,  
  timeout: 600000,
  maxRedirects: 10,
});

export { insuranceHttp };
